import Table, { ColumnsType } from "antd/es/table";
import { getTillStats } from "../../api/TillStats";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface TransactionInterface {
  currency: string;
  initialAmount: string | number;
  salesTotalAmount: string | number;
  receiptsTotalAmount: string | number;
  expectedAmountText: string | number;
}

type PropsType = {
  selected: number;
};

const TransactionTable = ({ selected }: PropsType) => {
  const [transactions, setTransactions] = useState<TransactionInterface[]>([]);

  const { t } = useTranslation("common");

  const columns: ColumnsType<TransactionInterface> = [
    {
      title: t("currency"),
      dataIndex: "currency",
      key: "currency",
      className: "table-header",
    },
    {
      title: t("total-initial"),
      dataIndex: "initialAmount",
      key: "initialAmount",
      align: "center"
    },
    {
      title: t("total-sale"),
      dataIndex: "salesTotalAmount",
      key: "salesTotalAmount",
    },
    {
      title: t("total-receipts"),
      dataIndex: "receiptsTotalAmount",
      key: "receiptsTotalAmount",
      align: "center"
    },
    {
      title: t("total-expected"),
      dataIndex: "expectedAmountText",
      key: "expectedAmountText",
      align: "center"
    },
  ];

  function numberWithCommasUSD(x: number) {
    return x && x.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  function numberWithCommasLBP(x: number) {
    return x && x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const { mutateAsync: getTillStatsMutation, isLoading: isTillStatsLoading } =
    useMutation("getTillStats", getTillStats);

  useEffect(() => {
    getTillStatsMutation(selected).then((res) => {
      let usdTran: TransactionInterface = {
        currency: "US Dollar",
        initialAmount: 0,
        salesTotalAmount: 0,
        receiptsTotalAmount: 0,
        expectedAmountText: 0,
      };
      let lbpTran: TransactionInterface = {
        currency: "Lebanese Pound",
        initialAmount: 0,
        salesTotalAmount: 0,
        receiptsTotalAmount: 0,
        expectedAmountText: 0,
      };
      usdTran.initialAmount = numberWithCommasUSD(
        res.data.initialTill[0].totalAmount
      );
      usdTran.salesTotalAmount = numberWithCommasUSD(
        res.data.salesAmount[0].totalAmount
      );
      usdTran.receiptsTotalAmount = numberWithCommasUSD(
        res.data.receiptsAmount[0].totalAmount
      );
      usdTran.expectedAmountText = numberWithCommasUSD(
        res.data.expectedAmount[0].totalAmount
      );
      lbpTran.initialAmount = numberWithCommasLBP(
        res.data.initialTill[1].totalAmount
      );
      lbpTran.salesTotalAmount = numberWithCommasLBP(
        res.data.salesAmount[1].totalAmount
      );
      lbpTran.receiptsTotalAmount = numberWithCommasLBP(
        res.data.receiptsAmount[1].totalAmount
      );
      lbpTran.expectedAmountText = numberWithCommasLBP(
        res.data.expectedAmount[1].totalAmount
      );
      setTransactions([usdTran, lbpTran]);
    });
  }, [getTillStatsMutation, selected]);

  return (
    <>
      <Table
        scroll={{ x: 1000 }}
        className="till-list"
        columns={columns}
        pagination={false}
        dataSource={transactions.map((transaction, index) => ({
          ...transaction,
          key: index, // Add a unique key based on the index
        }))}
        loading={isTillStatsLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
      />
    </>
  );
};

export default TransactionTable;
